import React from 'react';
import { ReceiptTextIcon, RulerIcon, TruckIcon } from 'lucide-react';
import { PERKS } from '../data/site';
const ICONS = {
  entrega: TruckIcon,
  factura: ReceiptTextIcon,
  medida: RulerIcon
};
interface PerksStripProps {
  tone?: 'dark' | 'light';
}
export function PerksStrip({
  tone = 'dark'
}: PerksStripProps) {
  const dark = tone === 'dark';
  return <ul className={`grid grid-cols-3 gap-px overflow-hidden rounded-lg ${dark ? 'bg-white/10' : 'bg-steel-200'}`} data-id="element-231" data-mp="3kslubp8d0gfr">
      {PERKS.map(perk => {
      const Icon = ICONS[perk.id];
      return <li key={perk.id} className={`flex flex-col items-center gap-1.5 px-2 py-3 text-center sm:flex-row sm:gap-3 sm:px-4 sm:text-left ${dark ? 'bg-navy-800' : 'bg-white'}`} data-id="element-232" data-mp="2s3y1n8la6os6">
            <Icon className="h-5 w-5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-233" data-mp="24hhry1hg9dgf" />
            <div className="min-w-0" data-id="element-234" data-mp="29f9kmxpx53lo">
              {/* Móvil: texto corto en 2 líneas máximo */}
              <p className={`text-xs font-semibold leading-snug sm:hidden ${dark ? 'text-white' : 'text-navy-900'}`} data-id="element-235" data-mp="17afnpta7zkzm">
                {perk.short}
              </p>
              <p className={`hidden text-sm font-semibold leading-tight sm:block ${dark ? 'text-white' : 'text-navy-900'}`} data-id="element-236" data-mp="12cw7intyoy51">
                {perk.title}
              </p>
              <p className={`hidden text-xs sm:block ${dark ? 'text-steel-400' : 'text-steel-600'}`} data-id="element-237" data-mp="sj5npw8s5bvo">{perk.text}</p>
            </div>
          </li>;
    })}
    </ul>;
}